// extracted by mini-css-extract-plugin
export default {"screen":"Modal_screen__pyoh3","show":"Modal_show__1CfSF","window":"Modal_window__nZFLX","container":"Modal_container__EY5Qx"};